import LexicalEditor from "./LexicalEditor";
import { UserAvatar as U } from "../../UserAvatar";

export const UserAvatar = ({ user }) => <U name={user.full_name} src={user.avatar_path} />


export const CommentEditor = ({ user, editorProps, ...props }) => {
	return <div className="flex items-start gap-2" {...props}>
		<UserAvatar user={user} />
		<Editor {...editorProps} className="flex-1 min-h-[100px] max-h-60" />
	</div>
}

export const Editor = ({ onSubmit, ...props }) => {
	return <LexicalEditor onSubmit={({ html, mentions, attachments }) => onSubmit({
		html,
		mentions,
		attachments
	})} {...props} />
}
